module.exports = __webpack_public_path__ + "img/equo.e6d52a90.png";